<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <!-- <div>
    <img [src]="imageUrl" [width]="imageWidth"
      [style]="'border: 2px dashed black; height: ' + getDimension(imageHeight) + ';'" />
  </div> -->
  <div class="flex flex-col justify-center h-full">
    <form (keydown.enter)="save()">
      <div class="flex flex-col gap-2 my-3">
        <uni-field label="Image URL">
          <input pInputText name="imageUrl" [(ngModel)]="imageUrl" />
        </uni-field>
        <div class="flex flex-row gap-2">
          <uni-field label="Width">
            <input pInputText name="imageWidth" [(ngModel)]="imageWidth" (change)="onWidthChange()" />
          </uni-field>
          <uni-field label="Height">
            <input pInputText name="imageHeight" [(ngModel)]="imageHeight" (change)="onHeightChange()" />
          </uni-field>
          <uni-field *ngIf="ratio">
            <p-checkbox name="aspect" id="aspect" [(ngModel)]="isAspect" [binary]="true"></p-checkbox>
            <label for="aspect" class="ml-2">Maintain aspect ratio</label>
          </uni-field>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2 w-full">
    <button pButton type="button" class="p-button-raised" [disabled]="!canSave()" (click)="save()">Ok
    </button>
    <button pButton type="button" class="p-button-raised" (click)="cancel()">Cancel
    </button>

    <div class="grow"></div>
    <p-button icon="pi pi-question" [rounded]="true" [text]="true" [raised]="true" [pTooltip]="'Choose an image from the list above, OR leave the URL with {{ids}} that are resolved when the template is rendered.
    Type the width and height to set the size that you want the image to have in the template.'" />
  </div>
</ng-template>